import { render, staticRenderFns } from "./SubscriptionForm.vue?vue&type=template&id=4504a735&scoped=true&"
import script from "./SubscriptionForm.vue?vue&type=script&lang=js&"
export * from "./SubscriptionForm.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionForm.vue?vue&type=style&index=0&id=4504a735&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4504a735",
  null
  
)

export default component.exports